import { IKksValidationResultDto } from 'types';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CheckBotEstablishedKks',

  props: {
    isValidatingKks: {
      type: Boolean,
      default: false,
    },
    kksList: {
      type: Array as () => string[],
      default: () => [],
    },
    kksValidationList: {
      type: Array as () => IKksValidationResultDto[],
      default: () => {},
    },
  },

  emits: ['kks-clicked', 'height-changed'],

  mounted() {
    this.emitListHeight();
  },

  methods: {
    isKksGreen(kks: string): boolean {
      return this.kksValidationList.some((v) => v.kks === kks && v.exists);
    },

    isKksYellow(kks: string): boolean {
      return this.kksValidationList.some(
        (v) => v.kks === kks && v.isValid && !v.exists,
      );
    },

    isKksRed(kks: string): boolean {
      return this.kksValidationList.some(
        (v) => v.kks === kks && !v.isValid && !v.exists,
      );
    },

    handleKksClick(kks: string) {
      this.$emit('kks-clicked', kks);
    },

    emitListHeight() {
      this.$nextTick(() => {
        this.$emit(
          'height-changed',
          (this.$refs.kksList as HTMLElement).offsetHeight,
        );
      });
    },
  },
});
